import { useQueryWithStore } from "react-admin";

const usePageCasaDiVetro = (name, params = {}, defaults = undefined) => {
  const { data, loaded } = useQueryWithStore({
    type: "getCasaDiVetroList",
    resource: name,
    payload: {
      ...params,
    },
  });
  return loaded ? data : defaults;
};
export default usePageCasaDiVetro;
